var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu_line"},_vm._l((_vm.enabledItems),function(item,index){return _c('menu-item',{key:index,attrs:{"roles":item.roles,"icon":item.icon,"fontAwesomeIcon":item.faIcon,"title":_vm.$t(item.i18nTitle),"link":item.to}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }